module.exports = ".center-cell {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .center-cell > button {\n    margin-left: auto; }\n  .box mat-table mat-row:hover {\n  cursor: default; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/students/exam-preparation-student/exam-preparation-student.component.scss
// module id = ./src/app/students/exam-preparation-student/exam-preparation-student.component.scss
// module chunks = main